import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React from 'react';
import { getStyle } from './utils.es.js';
import Ytb from 'react-youtube';
import styled from '@emotion/styled';

const StyledWrapper = styled.div(({ commonStyle }) => `
  ${getStyle(commonStyle)}
  width: 100%
`);
const StyledRatio = styled.div `
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  .container {
    height: 100%;
  }
`;
const StyledYtb = styled(Ytb) `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &.editor-mode {
    pointer-events: none;
  }
`;
const youtubeParser = (url) => {
    if (!url)
        return '';
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[7].length === 11 ? match[7] : '';
};
const Youtube = React.forwardRef((props, ref) => {
    const { className, link, isEditorMode = false, autoplay = false } = props, rest = __rest(props, ["className", "link", "isEditorMode", "autoplay"]);
    return (jsx(StyledWrapper, Object.assign({}, rest, { ref: ref }, { children: jsx(StyledRatio, { children: jsx(StyledYtb, { className: isEditorMode ? 'editor-mode' : '', containerClassName: "container", videoId: youtubeParser(link), opts: !isEditorMode
                    ? {
                        playerVars: {
                            autoplay: autoplay ? 1 : 0,
                            mute: autoplay ? 1 : 0,
                        },
                    }
                    : {} }) }) })));
});
Youtube.displayName = 'Youtube';

export { Youtube as Y };
